const e="undefined"==typeof window||"undefined"==typeof document,n=n=>e?null:n instanceof Node?n.ownerDocument:n?.current instanceof Node?n.current.ownerDocument:document;export{n as getOwnerDocument};
//# sourceMappingURL=index.js.map
